/**
 * MessageThreadSkeleton - Blank page placeholder while a thread loads.
 */
export function MessageThreadSkeleton() {
  return <div className="flex-1 h-full bg-background">{/* Blank page */}</div>;
}

export default MessageThreadSkeleton;
